import { useState, useEffect } from "react";
import { Upload } from "antd";
import { CloseOutlined, LinkOutlined } from '@ant-design/icons'; 

// Handler
import { uploadHDLR } from "../../../../../../../../handlers";

// Constants 

// Styles
import classStyles from "../../index.module.css";

const { 
    getBase64, 
    handleBeforeUpload,
    UploadVehicleIssueComment
} = uploadHDLR;

const CommentAttachment = ({ 
    value,
    setValue
}) => {
    const [loading, setLoading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]); 

    useEffect(() => {
        if (Array.isArray(value?.url) && value.url.length > 0) {
            const files = value.url.map(url => ({
                url,
                name: url.split('/').pop()
            }));
            setUploadedFiles(files);
        }
    }, [value?.url])

    const handleChange = (info) => {
        const { name, status, originFileObj, response = {} } = info.file;

        if (status === "uploading") {
            setLoading(true);
            return;
        }
        if (status === "done") {
            getBase64(originFileObj, () => {
                const { url } = response;
                setLoading(false);
                
                setValue({ ...value, url: [...uploadedFiles.map(file => file.url), url] });
                setUploadedFiles((prevFiles) => [
                    ...prevFiles,
                    { name, url }
                ]);
            });
        }
    };

    const handleRemoveFile = (fileUrl) => {
        setUploadedFiles((prevFiles) => prevFiles.filter(file => file.url !== fileUrl));
        
        setValue(prevValue => ({
            ...prevValue,
            url: prevValue.url?.filter(url => url !== fileUrl) 
        }));
    };

    return (
        <div className={classStyles["attachment-container"]}>
            <ul className={classStyles["uploaded-file-list"]}>
                {uploadedFiles.map((file, index) => (
                    <li key={index} className={classStyles["uploaded-file"]}>
                        <a href={file.url} target="_blank" rel="noopener noreferrer" style={{ color: "black" }}>
                            {file.name}
                        </a>
                        <CloseOutlined 
                            style={{ marginLeft: 8, color: '#878787', cursor: 'pointer' }} 
                            onClick={() => handleRemoveFile(file.url)} 
                        />
                    </li>
                ))}
            </ul>

            <Upload
                beforeUpload={handleBeforeUpload}
                onChange={handleChange}
                showUploadList={false}
                customRequest={UploadVehicleIssueComment}
                loading={loading}
            >
                <div className={classStyles["upload-button"]}>
                    <LinkOutlined />
                </div>
            </Upload>
        </div>
    );
};

export default CommentAttachment;
